import { DEFAULT_ERROR_MESSAGE } from '../constants/errors';

const readString = (value: unknown, key: string): string | undefined => {
  if (typeof value !== 'object' || value === null) {
    return undefined;
  }

  const field = (value as Record<string, unknown>)[key];

  return typeof field === 'string' && field.trim() ? field : undefined;
};

// A submit rejection has no fixed shape: the saga rejects with nothing, with the parsed body
// (`{message}` from the API, `{text}` for an HTML 5xx page, a problem+json object without a
// message), with a string, or with a thrown Error. Only the API's own `message` is shown as it
// came: `text` holds a whole proxy error page, which is neither readable nor safe to render.
export const getErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') {
    return error.trim() || DEFAULT_ERROR_MESSAGE;
  }

  if (error instanceof Error) {
    return error.message || DEFAULT_ERROR_MESSAGE;
  }

  return readString(error, 'message') ?? DEFAULT_ERROR_MESSAGE;
};
